export const Logo = ({ variant = "color", className = "" }) => (
  <img
    src={variant === "white" ? "/brand/brain-logo-white.png" : "/brand/brain-logo.png"}
    alt="BRaIN — Bengaluru Research and Innovation Network logo"
    className={`object-contain ${className}`}
  />
);

const NODES = [
  [210, 40], [300, 70], [120, 80], [200, 130], [330, 140],
  [90, 170], [170, 210], [280, 200], [280, 260], [40, 110], [370, 230],
];
const EDGES = [
  [0, 1], [0, 2], [0, 3], [1, 3], [1, 4], [2, 3], [2, 5], [3, 5],
  [3, 6], [3, 7], [3, 4], [4, 7], [7, 8], [5, 6], [2, 9], [4, 10], [7, 10],
];

export const NetworkGraphic = ({ className = "", node = "#A5E34D", line = "#A5E34D", animated = false }) => (
  <svg viewBox="0 0 410 300" className={className} aria-hidden="true" focusable="false">
    {EDGES.map(([a, b]) => (
      <line key={`${a}-${b}`} x1={NODES[a][0]} y1={NODES[a][1]} x2={NODES[b][0]} y2={NODES[b][1]} stroke={line} strokeWidth="2.5" strokeOpacity="0.7" />
    ))}
    {NODES.map(([x, y], i) => (
      <circle key={i} cx={x} cy={y} r={i === 3 ? 13 : 9} fill={node} className={animated ? "node-pulse" : ""} style={{ animationDelay: `${i * 0.35}s` }} />
    ))}
  </svg>
);

export const IllustrativeBadge = ({ label = "Illustrative content", tone = "light" }) => (
  <span
    className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-bold uppercase tracking-[0.12em] ${
      tone === "dark" ? "bg-white/10 text-white" : "bg-pale text-[#2F5A0C]"
    }`}
    data-testid="illustrative-badge"
  >
    <span className="h-1.5 w-1.5 rounded-full bg-brand-green" aria-hidden="true" />
    {label}
  </span>
);

const HN = [
  [760, 90], [880, 40], [990, 120], [1120, 60], [1260, 110], [1380, 50], [840, 210], [980, 260], [1110, 200],
  [1240, 250], [1370, 210], [900, 360], [1040, 400], [1180, 350], [1320, 390], [1430, 320], [700, 300], [1080, 500], [1260, 520], [620, 450],
];
const HE = [
  [0, 1], [1, 2], [2, 3], [3, 4], [4, 5], [0, 6], [6, 2], [2, 8], [8, 3], [8, 4], [4, 9], [9, 10], [5, 10], [6, 7], [7, 8], [8, 9],
  [7, 11], [11, 12], [12, 8], [12, 13], [13, 9], [13, 14], [14, 10], [14, 15], [10, 15], [16, 6], [16, 11], [12, 17], [17, 13], [13, 18], [18, 14], [19, 16], [19, 11],
];

export const HeroNetwork = ({ className = "" }) => (
  <svg viewBox="0 0 1440 560" preserveAspectRatio="xMaxYMid slice" className={className} aria-hidden="true" focusable="false">
    {HE.map(([a, b]) => (
      <line key={`${a}-${b}`} x1={HN[a][0]} y1={HN[a][1]} x2={HN[b][0]} y2={HN[b][1]} stroke="#FFFFFF" strokeOpacity="0.12" strokeWidth="1.2" />
    ))}
    {HN.map(([x, y], i) => (
      <circle key={i} cx={x} cy={y} r={i % 4 === 0 ? 6 : 4} fill="#A5E34D" fillOpacity={i % 4 === 0 ? 0.55 : 0.3} />
    ))}
  </svg>
);
